import { render, staticRenderFns } from "./SuspectReport.vue?vue&type=template&id=78c3673d&scoped=true"
import script from "./SuspectReport.vue?vue&type=script&lang=js"
export * from "./SuspectReport.vue?vue&type=script&lang=js"
import style0 from "./SuspectReport.vue?vue&type=style&index=0&id=78c3673d&prod&scoped=true&lang=css"
import style1 from "./SuspectReport.vue?vue&type=style&index=1&id=78c3673d&prod&scoped=true&lang=css"
import style2 from "./SuspectReport.vue?vue&type=style&index=2&id=78c3673d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c3673d",
  null
  
)

export default component.exports